import React from "react";
import "./whoWeAre.scss"

//Imagens:
import ImgWhoWeAre from "../../../../assets/homeImgs/who-we-are-mobile.png"
import { useTranslation } from "react-i18next";

const WhoWeAre = () => {

  const {t} = useTranslation()

  return (
    <div className="container-who-we-are-home">
      <div data-aos="zoom-in-up" className="texts-who-we-are">
        <h1>{t("home.who_we_are.title")}</h1>
        <p>{t('home.who_we_are.section_text_1')}</p>
        <br />
        <p>{t("home.who_we_are.section_text_2")}</p>
        <br />
        <p>{t("home.who_we_are.section_text_3")}</p>
        <br />
      </div>
      <div className="img-who-we-are">
        <img src={ImgWhoWeAre} alt="Quem somos" />
      </div>
    </div>
  );
};
export default WhoWeAre;
